var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSgwsDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#fff",
    stroke: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279c5",
    d: "M7.312 6.39q1.862-4.708 5.985-5.3a8.1 8.1 0 0 1 7.248 2.6 7.259 7.259 0 0 1 6.016-.4q2.232.81 3.239 4.01s4.86-.679 6.058 3.242-3.109 9.5-9.257 6.264q-.6 3.233-5.015 4.376-4.585.745-6.757-2.128-1.529 2.878-6.363 2.133a3.733 3.733 0 0 1-3.217-3.9q-5.012-1.777-4.1-6.6T7.312 6.39z",
    transform: "translate(13.934 20.333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#51c1cf",
    strokeWidth: "0.6px",
    d: "M13.059.034a8.794 8.794 0 0 1 7.75 2.551 7.746 7.746 0 0 1 6.426-.351c1.488.479 2.679 1.774 3.534 3.932a8.515 8.515 0 0 1 4.206 1.167A5.406 5.406 0 0 1 37.3 10.46a6.135 6.135 0 0 1-.248 3.907 7.747 7.747 0 0 1-2.534 3.365 6.79 6.79 0 0 1-3.617 1.38 7.406 7.406 0 0 1-3.538-.658A4.555 4.555 0 0 1 25.8 20.84a9.824 9.824 0 0 1-3.754 1.773 8.843 8.843 0 0 1-4.18-.029A6.225 6.225 0 0 1 15 20.849a5.055 5.055 0 0 1-2.652 1.685 10.55 10.55 0 0 1-4.458.086 4.947 4.947 0 0 1-2.76-1.637 4.569 4.569 0 0 1-.919-2.768 7.112 7.112 0 0 1-3.7-2.862 6.62 6.62 0 0 1-.64-4.707A6.549 6.549 0 0 1 2.1 6.5a6.737 6.737 0 0 1 4.391-1.274A8.375 8.375 0 0 1 13.059.034z",
    transform: "translate(13.848 20.262)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSgwsDefault);
export default __webpack_public_path__ + "static/media/sgws-default.c1ede01be796c9eddeb923bc66c9da3e.svg";
export { ForwardRef as ReactComponent };